package com.steamstreet.vegasful.browser.public

import com.steamstreet.vegasful.browser.account.Account
import com.steamstreet.vegasful.browser.account.GraphQL
import com.steamstreet.vegasful.browser.account.subscriptions.onClick
import com.steamstreet.vegasful.graphql.api.InteractInput
import com.steamstreet.vegasful.graphql.api.InteractionType
import org.w3c.dom.Element

/**
 * The add to calendar module.
 */
fun addToCalendar(element: Element) {
    val eventId = element.getAttribute("data-event-id")
    val eventName = element.getAttribute("data-event-name")

    element.onClick {
        if (Account.isLoggedIn()) {
            println("Add to calendar: ${eventId} ${eventName}")
            try {
                GraphQL.mutation {
                    subscriptions {
                        interact(InteractInput(InteractionType.CALENDAR, "events/${eventId}"))
                    }
                }
            } catch (t: Throwable) {
                GraphQL.mutation {
                    logClientEvent(t.stackTraceToString())
                }
            }
        }
    }
}